import { observer, inject } from "mobx-react";
import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Input,
  Label,
  Button,
  GridRow,
  GridColumn,
  GridContainer,
  Modal,
  Toastr,
  Img,
} from "arv-reactcomponents";
import ChangePassword from "../ChangePassword";
import { UserNameInput } from "../../Login";
import { blackboltConfig, MYACCOUNTPAGE } from "npmlinks-constants";

const { MYACCOUNT } = MYACCOUNTPAGE;

@inject("LoginStore")
@observer
class UserInformation extends Component {
  constructor() {
    super();
    this.state = {
      isPasswordPopupActive: false,
      nameState: MYACCOUNT.CTAS.EDIT,
      userNameValid: false,
    };
    this.usernameChange = this.usernameChange.bind(this);
    this.newUserName = this.newUserName.bind(this);
    this.openPasswordModal = this.openPasswordModal.bind(this);
    this.closePasswordModal = this.closePasswordModal.bind(this);
    this.changeNameState = this.changeNameState.bind(this);
  }

  changeNameState() {
    if (this.state.nameState === MYACCOUNT.CTAS.EDIT) {
      this.setState({ nameState: MYACCOUNT.CTAS.SAVE });
    } else if (this.state.nameState === MYACCOUNT.CTAS.SAVE) {
      this.newUserName(this.userNameFields.state.userName);
    }
  }

  get currentUserName() {
    return this.props.LoginStore.userName;
  }

  newUserName(name) {
    if (
      this.userNameFields.state.isUserInputValid &&
      name !== this.currentUserName
    ) {
      const req = {
        firstName: name,
      };
      this.setState({
        disableNameEdit: true,
        nameState: MYACCOUNT.CTAS.SAVING,
      });
      this.props.LoginStore.updateUserInfoAction(req)
        .then(() => {
          Toastr.showToastr({
            className: "nwc-toastr-list-success nw-toastr",
            message: blackboltConfig.CHANGE_INFO_SUCCESS,
            timeout: 3000,
          });
          this.setState({
            nameState: MYACCOUNT.CTAS.EDIT,
            disableNameEdit: false,
          });
        })
        .catch(() => {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: blackboltConfig.ERROR_MSG,
            timeout: 3000,
          });
          this.setState({
            nameState: MYACCOUNT.CTAS.SAVE,
            disableNameEdit: false,
          });
        });
    }
  }

  usernameChange(username, usernameObj) {
    const { isValid } = usernameObj;
    this.setState({ userNameValid: isValid });
  }

  openPasswordModal() {
    this.setState({ isPasswordPopupActive: true });
  }

  closePasswordModal() {
    this.setState({ isPasswordPopupActive: false });
  }

  render() {
    const { isPasswordPopupActive, nameState, userNameValid } = this.state;
    const { userName, mobileNumber, email } = this.props.LoginStore;
    return (
      <div className="nw-accordion-component-container">
        <GridContainer className="nw-userinfo-container">
          <GridRow className="nw-userinfo-usernamefields">
            <GridColumn className="nwc-grid-col-md-4 nw-userinfo-username-input">
              <Label>
                <div className="nw-userinfo-label">
                  {MYACCOUNT.INFO_FORM_LABELS.NAME}
                  <Button
                    className="nw-userinfo-btn-txt nwc-btn-primary-txt nwc-btn-xs"
                    onClick={this.changeNameState}
                    disabled={!userNameValid}
                  >
                    {nameState}
                  </Button>
                </div>
                <UserNameInput.component
                  className="nw-userinfo-inp  nwc-inp-xs"
                  placeholder={MYACCOUNT.PLACEHOLDERS.USER_NAME}
                  name="username"
                  userName={userName}
                  ref={values => {
                    this.userNameFields = values;
                  }}
                  disabled={
                    nameState === "edit" || nameState === MYACCOUNT.CTAS.SAVING
                  }
                  onValid={this.usernameChange}
                  showWarningIcon
                  showLoader={nameState === MYACCOUNT.CTAS.SAVING}
                />
              </Label>
            </GridColumn>
          </GridRow>
          <GridRow className="nw-userinfo-addressfields">
            <GridColumn className="nwc-grid-col-md-4">
              <Label>
                <div className="nw-userinfo-label">
                  {MYACCOUNT.INFO_FORM_LABELS.EMAIL}
                </div>
                <Input
                  id="account-email"
                  type="text"
                  value={email}
                  className="nw-userinfo-inp nwc-inp-xs"
                  name="email"
                  placeholder={MYACCOUNT.PLACEHOLDERS.EMAIL}
                  disabled
                />
              </Label>
            </GridColumn>
          </GridRow>
          <GridRow className="nw-userinfo-addressfields">
            <GridColumn className="nwc-grid-col-md-4">
              <Label>
                <div className="nw-userinfo-label">
                  {MYACCOUNT.INFO_FORM_LABELS.PHONE}
                </div>
                <Input
                  id="account-phone-number"
                  type="tel"
                  value={mobileNumber}
                  className="nw-userinfo-inp nwc-inp-xs"
                  name="phoneNumber"
                  placeholder={MYACCOUNT.PLACEHOLDERS.PHONE_NUMBER}
                  disabled
                />
              </Label>
            </GridColumn>
          </GridRow>
          <GridRow className="nw-userinfo-addressfields">
            <GridColumn className="nwc-grid-col-md-4">
              <Label>
                <div className="nw-userinfo-label">
                  {MYACCOUNT.INFO_FORM_LABELS.PASSWORD}
                  <Button
                    className="nw-userinfo-btn-txt nwc-btn-primary-txt nwc-btn-xs"
                    onClick={this.openPasswordModal}
                  >
                    {MYACCOUNT.CTAS.CHANGE}
                  </Button>
                </div>
                <Input
                  id="account-password"
                  type="password"
                  value="password"
                  className="nw-userinfo-inp nwc-inp-xs"
                  name="password"
                  placeholder={MYACCOUNT.PLACEHOLDERS.PASSWORD}
                  disabled
                />
              </Label>
            </GridColumn>
          </GridRow>
        </GridContainer>
        <Modal
          isOpen={isPasswordPopupActive}
          onClose={this.closePasswordModal}
          className="nw-changepw-popup"
        >
          <ChangePassword.component
            closePasswordModal={this.closePasswordModal}
          />
        </Modal>
      </div>
    );
  }
}

UserInformation.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    updateUserInfoAction: PropTypes.func,
    userName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    mobileNumber: PropTypes.string,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: UserInformation.wrappedComponent,
  component: UserInformation,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/MyAccountComponent/UserInformation/index.js